import {addDays, differenceInDays, format, parse} from "date-fns";

export const date = {
    format(date, dateFormat) {
        return format(new Date(date), dateFormat);
    },
    createFromFormat(dateString, format) {
        return parse(dateString, format, new Date());
    },
    addDays(date, amount) {
        return addDays(new Date(date), amount)
    },
    diffInDays(laterDate, earlierDate) {
        return differenceInDays(laterDate, earlierDate);
    },
    toLongDate(date) {
        return format(new Date(date), 'MMMM d, yyyy');
    },
}
